export { SweetAlertService } from './src/index'


// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/ngx-sweetalert2/index.ts